import { defineNuxtPlugin } from '#app'
import { Background } from '@vue-flow/background'
import { ControlButton, Controls } from '@vue-flow/controls'
import { VueFlow } from '@vue-flow/core'
import '@vue-flow/core/dist/style.css'
import '@vue-flow/core/dist/theme-default.css'
import { NodeResizer } from '@vue-flow/node-resizer'

export default defineNuxtPlugin(nuxtApp => {
  // Optionally register VueFlow as a global component
  nuxtApp.vueApp.component('VueFlow', VueFlow)
  
  nuxtApp.vueApp.component('Background', Background)
  nuxtApp.vueApp.component('ControlButton', ControlButton)
  nuxtApp.vueApp.component('Controls', Controls)
  nuxtApp.vueApp.component('NodeResizer', NodeResizer)
  
})

